import { call, put, select, takeLatest } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// Initial state
const initialState = {
  page: null,
  data: null,
  error: false,
  loading: false,
  loaded: false,
  dsetination: null,
};

// Slice
const handleServiceSlice = createSlice({
  name: "handleService",
  initialState,
  reducers: {
    serviceUp() {},
    serviceDown() {},
    fetchDataSuccess(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: false,
        loaded: true,
      };
    },
    fetchDataFailure(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: action.payload,
        loaded: true,
      };
    },
  },
});

export const { serviceUp, serviceDown, fetchDataSuccess, fetchDataFailure } =
  handleServiceSlice.actions;

export default handleServiceSlice.reducer;

//saga
function* handleServiceUpSaga(action) {
  const peerIp = yield select((state) => state.peerIp.ip);
  try {
    const { headers = {}, apiUrl } = action.payload;
    const apiService = axios.create({
      headers: {
        ...headers,
        user_ip: peerIp
      }
    });
    const response = yield call(apiService.put, apiUrl);
    yield put(fetchDataSuccess(response.data));
  } catch (error) {}
}

function* handleServiceDownSaga(action) {
  const peerIp = yield select((state) => state.peerIp.ip);
  try {
    const { headers = {}, apiUrl } = action.payload;
    const apiService = axios.create({
      headers: {
        ...headers,
        user_ip: peerIp
      }
    });
    const response = yield call(apiService.put, apiUrl);
    yield put(fetchDataSuccess(response.data));
  } catch (error) {}
}

// API 호출을 감시하는 Saga 함수
export function* handleServiceSaga() {
  yield takeLatest(serviceUp.type, handleServiceUpSaga);
  yield takeLatest(serviceDown.type, handleServiceDownSaga);
}
